import { ComponentProps } from 'react';
import { NavigationMenuItem as OriginalNavigationMenuItem } from '@cld/navigation-menu';

export type NavigationMenuItemProps = ComponentProps<typeof OriginalNavigationMenuItem>;
export const NavigationMenuItem = (props: NavigationMenuItemProps) => (
  <OriginalNavigationMenuItem verticalPadding="none" {...props}></OriginalNavigationMenuItem>
);
